module.exports = __webpack_public_path__ + "icons/original/small/small-c3.8ecb4d1c7b95cff1b3f7a4e3e0342ad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-c3.png
// module id = mcFw
// module chunks = app